/* Base trigger styles — shared by all variants. */

:host {
  --km-trigger-size: 40px;
  --km-trigger-bg: var(--km-primary, #1a1a1a);
  --km-trigger-color: var(--km-primary-text, #ffffff);
  --km-trigger-offset: 16px;
}

:host([hidden]) {
  display: none !important;
}

button {
  border: none;
  margin: 0;
  font-family: inherit;
  cursor: pointer;
  text-align: inherit;
  align-items: center;
  justify-content: center;
  gap: 0.4em;
}

button:focus-visible {
  outline: 2px solid var(--km-trigger-color, currentColor);
  outline-offset: 2px;
}

.km-trigger__icon {
  font-size: 1.15em;
  line-height: 1;
}

@media (prefers-reduced-motion: reduce) {
  button {
    transition: none !important;
    animation: none !important;
  }
}

@media print {
  :host {
    display: none !important;
  }
}
